import React from "react";
import PropTypes from "prop-types";

const VoucherTitle = ({ intro, consumableDescription, additionalClasses }) => {
    return (
        <div className={`${additionalClasses ? `${additionalClasses}` : "voucher__title"}`}>
            {intro || consumableDescription}
        </div>
    );
};

VoucherTitle.propTypes = {
    intro: PropTypes.string,
    consumableDescription: PropTypes.string
};

export default VoucherTitle;
